<template>
  <div class="m-hero-item hero d-flex flex-column-reverse flex-md-column">
    <div class="m-hero-item__content p-6 p-md-10 p-lg-12 d-flex flex-column justify-content-center text-center h-100">
      <div class="row justify-content-center">
        <div class="col-md-12 col-xl-6">
          <h2 class="mb-4 h2">
            {{ heroItem.headline }}
          </h2>
          <p v-if="!$isNullOrUndefined(heroItem.subline)" class="mb-6">
            {{ heroItem.subline }}
          </p>
          <div v-if="!$isNullOrUndefined(heroItem.link)">
            <base-link
              class="text-decoration-none mb-6"
              :link="heroItem.link.url"
              :target="heroItem.link.target"
            >
              <base-button
                class="a-button -primary"
              >
                {{ heroItem.link.name }}
              </base-button>
            </base-link>
          </div>
        </div>
      </div>
    </div>
    <base-image
      v-if="!$isNullOrUndefined(image)"
      :url="image.url"
      :width="2170"
      :height="1500"
      :ratio="2170/1500"
      :alt-text="heroItem.imageAltText"
      class="h-100"
      image-class="m-hero-item__image position-absolute h-100"
    />
  </div>
</template>

<script>
import BaseImage from '@/components/atoms/BaseImage';
import BaseButton from '@/components/atoms/BaseButton';
import BaseLink from '@/components/atoms/BaseLink';

export default {
  name: 'HeroItem',
  components: {
    BaseButton,
    BaseLink,
    BaseImage,
  },
  props: {
    heroItem: {
      default () {
        return {};
      },
      requirred: true,
      type: Object
    },
    isActive: {
      default: false,
      requirred: true,
      type: Boolean
    }
  },
  computed: {
    image () {
      return !this.$isNullOrUndefined(this.heroItem?.image) && this.heroItem?.image?.length ? this.heroItem.image[0] : null;
    }
  },
};
</script>
